import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${p => p.revert ? 'transprent' : p.theme.primaryColor};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${props => props.theme.container.wider.width};
  font-size: 1.4rem;
  line-height: 2.8rem;
  letter-spacing: 0.1rem;
  color: ${p => p.revert ? p.theme.primaryColor : p.theme.textColor};
  padding: 2rem 0;
  ${media.small`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
  `};
`;

export const Name = styled.div`
  font-size: 1.6rem;
  padding-right: 2rem;
`;

export const TCs = styled.div`
  text-decoration: none;
  text-transform: capitalize;
  cursor: pointer;
  color: ${p => p.revert ? p.theme.primaryColor : p.theme.textColor};
`;

export const Right = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  ${media.small`
    width: 100%;
  `};
`;

export const PoweredBy = styled.div`
  display: flex;
`;

export const FooditLogo = styled.img`
  height: 2rem;
  max-width: 100%;
`;

export const UrlLink = styled.a`
  outline: none;
  display: flex;
  align-items: center;
  padding-left: 1rem;
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/Footer.style.js